
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import './index.css'; // ✅ Aquí importas tu CSS que contiene Tailwind
import "./App.css";
import "./utils/axiosAuth"; // adjunta el token de sesión a todas las peticiones
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId="125655390887-i9c7qacvu3feop5kp1aviqeigoqf9o7n.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);


//125655390887-i9c7qacvu3feop5kp1aviqeigoqf9o7n.apps.googleusercontent.com